(function () {
    const $body = $('body');
    UX.alertPopup = {
        config: {
            $toggle: '[data-toggle="alert"]',
            $target: null,
            $actions: null,
            $approve: '[data-action="approve"]',
            $cancel: '[data-action="cancel"]',
            $url: null,
        },
        init: function () {
            if (config.enableAlertPopupAccessibility) this.accessibility.init();
            this.set();
            this.controls();
        },
        accessibility: {
            init: function () {
                let $content = $('main.content');
                if ($content.length) {
                    $content.after($('.ux-modal-alert'));
                }
            },
            show: function () {
                $('.content, .footer, .header').attr('aria-hidden', true);
            },
            hide: function () {
                $('.content, .footer, .header').removeAttr('aria-hidden');
            },
        },
        set: function () {
            this.config.$actions = document.querySelectorAll(this.config.$toggle);
            this.config.$approve = document.querySelectorAll(this.config.$approve);
            this.config.$cancel = document.querySelectorAll(this.config.$cancel);
        },
        controls: function () {
            this.config.$actions.forEach(action => {
                action.addEventListener('click', e => {
                    this.onClick(e);
                });
            });
            this.config.$approve.forEach(action => {
                action.addEventListener('click', e => {
                    this.action();
                });
            });
            this.config.$cancel.forEach(action => {
                action.addEventListener('click', e => {
                    this.hide($(action).closest('.alert'));
                });
            });
        },
        onClick: function (e) {
            e.preventDefault();
            this.config.$target = e.currentTarget.getAttribute('data-target');
            this.config.$url = e.currentTarget.href;
            this.show(this.config.$target);
        },
        redirect: function (value) {
            window.location.href = value;
        },
        show: function (target) {
            $body.attr('data-active', 'modal');
            this.accessibility.show();
            $(target).addClass('js--open');
            $(target).attr('open', true);
        },
        hide: function (target) {
            this.accessibility.hide();
            $(target).removeClass('js--open');
            $(target).removeAttr('open');
        },
        action: function () {
            this.redirect(this.config.$url);
        },
    };
})();
